import { Typography } from '@mui/material';

import { InteractiveMap } from '@occc-app/design-system';
import { NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';

import { LocationAddressGeolocation } from './location-address-geolocation-card.types';

type LocationAddressGeolocationCardMapProps = {
  hasAddress: boolean;
  geolocation: LocationAddressGeolocation | null;
  onMarkerDrag?: (coords: LocationAddressGeolocation) => void;
};

export const LocationAddressGeolocationCardMap = ({
  hasAddress,
  geolocation,
  onMarkerDrag,
}: LocationAddressGeolocationCardMapProps) => {
  const onMarkerDragComplete = (event: google.maps.MapMouseEvent) => {
    if (onMarkerDrag && event.latLng) {
      onMarkerDrag({ latitude: event.latLng.lat(), longitude: event.latLng.lng() });
    }
  };

  if (!hasAddress) {
    return (
      <Typography px={2} color='textSecondary'>
        This location is missing an address and cannot be updated. Please contact your Network Admin
        to resolve this.
      </Typography>
    );
  }

  const coordinates = geolocation
    ? { lat: geolocation.latitude, lng: geolocation.longitude }
    : undefined;

  return (
    <>
      {geolocation ? (
        <InteractiveMap
          coordinates={coordinates}
          height={100}
          draggable={!!onMarkerDrag}
          markerDraggable={!!onMarkerDrag}
          onMarkerDragEnd={onMarkerDragComplete}
        />
      ) : (
        <Typography px={2} color='textSecondary'>
          {NO_DATA_PLACEHOLDER}
        </Typography>
      )}
    </>
  );
};
